import Swiper, { Navigation, Autoplay } from "swiper";

$(document).ready(function () {
    homeHeadSliderInit();

    homeMainTypeCategoriesSlidersInit();

    homeJobsTabsInit();

    homeJobsSlidersInit();

    verifiedBusinessesSliderInit();

    approvedBusinessesSliderInit();

    localServicesSliderInit();

    homeNewsSliderInit();

    homeCategoriesToggle();
});

window.$mainPlayer = null;
window.$currentAdvertisementIndex = 0;
window.$advertisementTimeout = null;
window.$advertisementVideoEndHandler = null;

const ADVERTISEMENT_VIDEO_MUTED_STORAGE_KEY = 'armeniansusa.advertisementVideoMuted';

const readAdvertisementVideoMutedPreference = () => {
    try {
        return localStorage.getItem(ADVERTISEMENT_VIDEO_MUTED_STORAGE_KEY) === '1';
    } catch (error) {
        return false;
    }
};

const persistAdvertisementVideoMutedPreference = () => {
    try {
        localStorage.setItem(ADVERTISEMENT_VIDEO_MUTED_STORAGE_KEY, '1');
    } catch (error) {
        // Ignore storage failures (private mode, quota, etc.).
    }
};

const advertisementPlyrOptions = {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen'],
    settings: ['quality', 'speed'],
};

const clearAdvertisementRotation = () => {
    if (window.$advertisementTimeout) {
        clearTimeout(window.$advertisementTimeout);
        window.$advertisementTimeout = null;
    }

    const video = document.getElementById('mainPlayerVideo');
    if (video && window.$advertisementVideoEndHandler) {
        video.removeEventListener('ended', window.$advertisementVideoEndHandler);
        window.$advertisementVideoEndHandler = null;
    }
};

const destroyAdvertisementPlayer = () => {
    if (!window.$mainPlayer) {
        return;
    }

    try {
        window.$advertisementPlayerTearingDown = true;
        window.$mainPlayer.pause();
        window.$mainPlayer.destroy();
    } catch (error) {
        // Plyr may already be torn down when switching ads quickly.
    } finally {
        window.$advertisementPlayerTearingDown = false;
    }

    window.$mainPlayer = null;
};

const clearAdvertisementPlayerContent = (container) => {
    if (!container) {
        return;
    }

    destroyAdvertisementPlayer();

    // Plyr wrappers can remain after destroy() and block hover on the next ad.
    container.querySelectorAll('.plyr, .advertisements-player-content, .advertisements-player-placeholder, video, img').forEach((element) => {
        element.remove();
    });
};

const bindAdvertisementPlayerPreferences = (player) => {
    if (!player || player._advertisementPreferencesBound) {
        return;
    }

    player._advertisementPreferencesBound = true;

    player.on('volumechange', () => {
        if (player.muted || player.volume === 0) {
            persistAdvertisementVideoMutedPreference();
        }
    });

    player.on('pause', () => {
        if (window.$advertisementPlayerTearingDown) {
            return;
        }

        persistAdvertisementVideoMutedPreference();
    });
};

const initAdvertisementPlyr = (video) => {
    const shouldStartMuted = readAdvertisementVideoMutedPreference();

    if (shouldStartMuted) {
        video.muted = true;
        video.defaultMuted = true;
    }

    window.$mainPlayer = new Plyr(video, advertisementPlyrOptions);
    bindAdvertisementPlayerPreferences(window.$mainPlayer);

    window.$mainPlayer.on('ready', () => {
        if (shouldStartMuted) {
            window.$mainPlayer.muted = true;
        }

        window.$mainPlayer.play().catch(() => {});
    });
};

const bindAdvertisementNavigation = () => {
    const prevBtn = document.getElementById('advertisementsPlayerPrev');
    const nextBtn = document.getElementById('advertisementsPlayerNext');

    if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            prevAdvertisement();
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            nextAdvertisement();
        });
    }
};

const updateAdvertisementVisitLink = (container, link) => {
    if (!container) {
        return;
    }

    let visitLink = container.querySelector('.advertisements-player-visit-link');

    if (!link) {
        if (visitLink) {
            visitLink.remove();
        }

        return;
    }

    if (!visitLink) {
        visitLink = document.createElement('a');
        visitLink.className = 'advertisements-player-visit-link';
        visitLink.target = '_blank';
        visitLink.rel = 'noopener noreferrer';
        container.appendChild(visitLink);
    }

    visitLink.href = link;
    visitLink.innerHTML = `${window.advertisementVisitWebsiteLabel || 'Visit website'} <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i>`;
};

const homeHeadSliderInit = () => {
    const mainPlayerContainer = document.getElementById('advertisementsMainPlayer');

    if (!mainPlayerContainer || !window.advertisementsData || window.advertisementsData.length === 0) {
        return;
    }

    // If there's only one advertisement, no need for rotation
    if (window.advertisementsData.length <= 1) {
        const mainVideo = document.getElementById('mainPlayerVideo');
        if (mainVideo) {
            initAdvertisementPlyr(mainVideo);
        }

        updateAdvertisementVisitLink(mainPlayerContainer, window.advertisementsData[0]?.link ?? null);

        return;
    }

    bindAdvertisementNavigation();

    // Initialize first advertisement
    initializeAdvertisement(0);

    // Set up rotation for first advertisement
    setupAdvertisementRotation(0);
}

const initializeAdvertisement = (index) => {
    const mainPlayerContainer = document.getElementById('advertisementsMainPlayer');
    if (!mainPlayerContainer || !window.advertisementsData || index >= window.advertisementsData.length) {
        return;
    }

    const advertisement = window.advertisementsData[index];
    window.$currentAdvertisementIndex = index;

    clearAdvertisementRotation();
    clearAdvertisementPlayerContent(mainPlayerContainer);

    // Create new content based on type
    if (advertisement.type === 'video') {
        const video = document.createElement('video');
        video.id = 'mainPlayerVideo';
        video.className = 'advertisements-player-content';
        video.setAttribute('playsinline', '');

        const source = document.createElement('source');
        source.src = advertisement.url;
        source.type = 'video/mp4';
        video.appendChild(source);

        mainPlayerContainer.appendChild(video);
        initAdvertisementPlyr(video);
    } else if (advertisement.type === 'image') {
        const img = document.createElement('img');
        img.id = 'mainPlayerImage';
        img.className = 'advertisements-player-content';
        img.src = advertisement.url;
        img.alt = 'Advertisement';

        mainPlayerContainer.appendChild(img);
    }

    updateAdvertisementVisitLink(mainPlayerContainer, advertisement.link ?? null);
}

const setupAdvertisementRotation = (index) => {
    if (!window.advertisementsData || window.advertisementsData.length <= 1) {
        return;
    }

    const advertisement = window.advertisementsData[index];

    if (advertisement.type === 'video') {
        const video = document.getElementById('mainPlayerVideo');
        if (video) {
            window.$advertisementVideoEndHandler = () => {
                clearAdvertisementRotation();
                nextAdvertisement();
            };
            video.addEventListener('ended', window.$advertisementVideoEndHandler);
        }
    } else if (advertisement.type === 'image') {
        // For images, wait 10 seconds then move to next
        window.$advertisementTimeout = setTimeout(() => {
            nextAdvertisement();
        }, 10000); // 10 seconds
    }
}

const goToAdvertisement = (index) => {
    if (!window.advertisementsData || window.advertisementsData.length <= 1) {
        return;
    }

    const total = window.advertisementsData.length;
    const normalizedIndex = ((index % total) + total) % total;

    clearAdvertisementRotation();
    initializeAdvertisement(normalizedIndex);
    setupAdvertisementRotation(normalizedIndex);
};

const prevAdvertisement = () => {
    goToAdvertisement(window.$currentAdvertisementIndex - 1);
};

const nextAdvertisement = () => {
    goToAdvertisement(window.$currentAdvertisementIndex + 1);
};

const businessesHomeSliderInit = (sliderSelector, prevSelector, nextSelector) => {
    const slider = document.querySelector(sliderSelector);
    if (!slider) {
        return;
    }

    const slideCount = slider.querySelectorAll('.swiper-slide').length;

    new Swiper(sliderSelector, {
        modules: [Navigation, Autoplay],
        slidesPerView: 2.4,
        spaceBetween: 12,
        loop: false,
        watchOverflow: true,
        watchSlidesProgress: true,
        autoplay: slideCount > 1 ? {
            delay: 4200,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        } : false,
        navigation: {
            prevEl: prevSelector,
            nextEl: nextSelector,
        },
        breakpoints: {
            991: {
                slidesPerView: 7,
                spaceBetween: 12,
            },
            768: {
                slidesPerView: 5,
            },
            576: {
                slidesPerView: 3.2,
            },
        },
    });
};

const initHomeSliderWhenVisible = (sliderOrSelector, initFn) => {
    const slider = typeof sliderOrSelector === 'string'
        ? document.querySelector(sliderOrSelector)
        : sliderOrSelector;

    if (!slider || slider.dataset.swiperReady === '1') {
        return;
    }

    const start = () => {
        if (slider.dataset.swiperReady === '1') {
            return;
        }

        slider.dataset.swiperReady = '1';
        initFn();
    };

    if (!('IntersectionObserver' in window)) {
        start();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            start();
        }
    }, { rootMargin: '240px 0px' });

    observer.observe(slider);
};

const verifiedBusinessesSliderInit = () => {
    initHomeSliderWhenVisible('.verified-businesses-slider', () => {
        businessesHomeSliderInit(
            '.verified-businesses-slider',
            '.verified-businesses-slider-prev',
            '.verified-businesses-slider-next',
        );
    });
};

const approvedBusinessesSliderInit = () => {
    initHomeSliderWhenVisible('.approved-businesses-slider', () => {
        businessesHomeSliderInit(
            '.approved-businesses-slider',
            '.approved-businesses-slider-prev',
            '.approved-businesses-slider-next',
        );
    });
};

const localServicesSliderInit = () => {
    initHomeSliderWhenVisible('.local-services-slider', () => {
        businessesHomeSliderInit(
            '.local-services-slider',
            '.local-services-slider-prev',
            '.local-services-slider-next',
        );
    });
};

const homeNewsSliderInit = () => {
    initHomeSliderWhenVisible('.home-news-slider', () => {
        const slider = document.querySelector('.home-news-slider');
        if (!slider) {
            return;
        }

        const slideCount = slider.querySelectorAll('.swiper-slide').length;

        new Swiper(slider, {
            modules: [Navigation, Autoplay],
            slidesPerView: 1.15,
            spaceBetween: 12,
            loop: false,
            watchOverflow: true,
            watchSlidesProgress: true,
            autoplay: slideCount > 1 ? {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            } : false,
            navigation: {
                prevEl: '.home-news-slider-prev',
                nextEl: '.home-news-slider-next',
            },
            breakpoints: {
                991: {
                    slidesPerView: 3,
                    spaceBetween: 14,
                },
                768: {
                    slidesPerView: 2.2,
                },
                576: {
                    slidesPerView: 1.6,
                },
            },
        });
    });
};

const homeMainTypeCategoriesSliderOptions = {
    modules: [Navigation],
    slidesPerView: 2.4,
    spaceBetween: 16,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    breakpoints: {
        991: {
            slidesPerView: 6,
        },
        768: {
            slidesPerView: 5,
        },
        576: {
            spaceBetween: 32,
            slidesPerView: 3,
        },
    },
};

const homeMainTypeCategoriesSlidersInit = () => {
    document.querySelectorAll('.home-type-categories-slider').forEach((slider) => {
        const sliderKey = Array.from(slider.classList)
            .find((className) => className.startsWith('home-type-categories-slider--'))
            ?.replace('home-type-categories-slider--', '');

        if (!sliderKey) {
            return;
        }

        initHomeSliderWhenVisible(slider, () => {
            new Swiper(slider, {
                ...homeMainTypeCategoriesSliderOptions,
                navigation: {
                    prevEl: `.home-type-categories-slider-prev--${sliderKey}`,
                    nextEl: `.home-type-categories-slider-next--${sliderKey}`,
                },
            });
        });
    });
};

const homeJobsSliderOptions = {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 12,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    breakpoints: {
        576: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        991: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
};

const initHomeJobsSlider = (slider) => {
    if (!slider || slider.dataset.homeJobsSwiperReady === '1') {
        return;
    }

    const variant = slider.classList.contains('home-jobs-slider--looking') ? 'looking' : 'offering';

    slider.dataset.homeJobsSwiperReady = '1';
    window.homeJobsSwipers = window.homeJobsSwipers || {};
    window.homeJobsSwipers[variant] = new Swiper(slider, {
        ...homeJobsSliderOptions,
        navigation: {
            prevEl: `.home-jobs-slider-prev--${variant}`,
            nextEl: `.home-jobs-slider-next--${variant}`,
        },
    });
};

const homeJobsSlidersInit = () => {
    document.querySelectorAll('.home-jobs-slider').forEach((slider) => {
        const panel = slider.closest('[data-home-jobs-panel]');
        const isActive = !panel || !panel.hasAttribute('hidden');

        if (!isActive) {
            return;
        }

        initHomeSliderWhenVisible(slider, () => initHomeJobsSlider(slider));
    });
};

const homeJobsTabsInit = () => {
    const section = document.querySelector('.home-jobs-section');

    if (!section) {
        return;
    }

    const tabs = section.querySelectorAll('[data-home-jobs-tab]');
    const panels = section.querySelectorAll('[data-home-jobs-panel]');

    if (!tabs.length || !panels.length) {
        return;
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => {
            event.preventDefault();

            const target = tab.dataset.homeJobsTab;

            tabs.forEach((item) => {
                const isActive = item === tab;
                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            panels.forEach((panel) => {
                const isActive = panel.dataset.homeJobsPanel === target;
                panel.classList.toggle('is-active', isActive);

                if (isActive) {
                    panel.removeAttribute('hidden');
                    const slider = panel.querySelector('.home-jobs-slider');
                    if (slider) {
                        initHomeJobsSlider(slider);
                    }
                    window.homeJobsSwipers?.[target]?.update();
                } else {
                    panel.setAttribute('hidden', '');
                }
            });
        });
    });
};

const homeCategoriesToggle = () => {
    const subCategoryList = $('.home-head-categories-wrapper-list');
    const mobileCategoryClose = $('#homeHeadMobileCategoriesClose');
    const mobileCategoryPrev = $('#homeHeadMobileCategoriesPrev');
    const mobileWrapper = $('.home-head-mobile-categories');
    const mobileCategoryBtn = $('.mobile-category-btn');
    const wrapper = $('.home-head-categories-wrapper');
    const subCategoryBtn = $('[data-mouseover]');
    const categoryBtn = $('[data-category]');
    const isMobile = $(window).width() <= 991;
    let step = 0;

    const categoryClickHandle = ($this) => {
        const categoryId = $this.data('category');

        $(categoryId).addClass('show');
        $this.addClass('active');
        categoryBtn.not($this).removeClass('active');

        step++;

        setTimeout(() => {
            wrapper.not($(categoryId)).removeClass('show');
        }, 200);
    }

    const subCategoryClickHandle = ($this) => {
        const subCategoryId = $this.data('mouseover');

        $this.addClass('active');
        subCategoryBtn.not($this).removeClass('active');
        $(subCategoryId).addClass('show');
        subCategoryList.not($(subCategoryId)).removeClass('show');
    }

    const mobileCategoryWrapperClose = () => {
        mobileWrapper.removeClass('show');
        categoryBtn.removeClass('active');
        wrapper.removeClass('show');
        $('body').removeClass('overflow-hidden');
        step = 0;
    }

    categoryBtn.on('click', function (e) {
        e.stopPropagation();

        categoryClickHandle($(this));
    });

    subCategoryBtn.on('mouseover', function () {
        subCategoryClickHandle($(this));
    });

    wrapper.on('click', (e) => e.stopPropagation());

    $(window).on('click', function () {
        if (!isMobile) {
            wrapper.removeClass('show');
            categoryBtn.removeClass('active');
            subCategoryList.removeClass('d-block');
        }
    });

    mobileCategoryBtn.on('click', function () {
        mobileWrapper.addClass('show');
        $('body').addClass('overflow-hidden');
        step++;
    });

    mobileCategoryClose.on('click', mobileCategoryWrapperClose);

    subCategoryBtn.on('click', function () {
        subCategoryClickHandle($(this));
        step++;
    });

    mobileCategoryPrev.on('click', function () {
        if (step === 1) {
            mobileCategoryWrapperClose();
        } else if (step === 2) {
            wrapper.removeClass('show');
            categoryBtn.removeClass('active');
            step--;
        } else if (step === 3) {
            subCategoryList.removeClass('show');
            subCategoryBtn.removeClass('active');
            step--;
        }
    });

    if (isMobile) {
        subCategoryBtn.off('mouseover');
    }
}
